import Buttons from './Button.vue';

export default Buttons;
